import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography } from '@mui/material'
import * as Yup from 'yup'
import { ErrorMessage, Formik } from 'formik'
import NewInput from '../../../components/input/NewInput'
import closeIcon from '../../../assets/icons/close.svg'
import { Dropdown } from 'primereact/dropdown'
import HorizontalLine from '../../../assets/icons/Line33.svg'
import pencilIcon from '../../../assets/icons/pencil1.svg'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { capitalizeFirstLetter, dynamicCustomFilter, handleInventory } from '../../../utility/genricFunction'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import RightDrawer from '../../../components/drawer/Drawer'
import ParentDataTable from '../../../components/data-table/ParentDataTable'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import UseAuthorization from '../../../utility/useAuthorization'
import Button from '../../../components/button/Button'
import Loader from '../../../components/loader/Loader'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import PopupBox from '../../../components/popup/PopupBox'
import { createDesignation, editDesignation, getDesignation } from '../../../store/builders/MasterConfig/master.config.builder'
import './designation.scss'

const Designation = () => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { loading, designation } = useSelector((state) => state.masterConfig)
  const [singleDesignationData, setsingleDesignationData] = useState('')

  useEffect(() => {
    dispatch(getDesignation())
    return () => dispatch({ type: 'masterConfig/clearExtraReducers' })
  }, [])

  // const [loader, setLoader] = useState(true);

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    designationName: { value: null, matchMode: 'dynamic_custom' },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [open, setOpen] = useState(false)
  const [editDesignationDrawer, seteditDesignationDrawer] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber, setfilterNumber] = useState(false)

  const [selectedValue, setSelectedValue] = useState(null)

  const statuses = [
    { label: 'active', value: 'active' },
    { label: 'inactive', value: 'inactive' },
  ]

  useEffect(() => {
    setFilteredData(designation)
  }, [designation])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(designation, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleDrawerForEditDesignation = (newOpen, designation) => () => {
    seteditDesignationDrawer(newOpen)
    setIsOpen(true)
    setsingleDesignationData(designation)
  }

  const validationSchema = Yup.object().shape({
    designationName: Yup.string().required('Designation is required'),
  })

  const handleFormSubmit = (value) => {
    dispatch(createDesignation({ designationName: value.designationName, dispatch, setOpen }))
  }

  const DrawerList = (
    <Box className='timetable-drawer' role='presentation'>
      <Box className='timetable-drawer-header flex justify-between align-center'>
        <Typography className='timetable-drawer-title'>Add Designation</Typography>
        {/* <Typography className='timetable-drawer-title'>{UI_CONSTANT.MASTER_CONFIG.BANKS.ADD_BANK}</Typography> */}
        <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={toggleDrawer(false)} />
      </Box>
      <Box className='drawer-horizontal-line' />
      <Formik
        initialValues={{
          designationName: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(value) => {
          handleFormSubmit(value)
        }}
      >
        {({ values, handleChange, handleSubmit, setFieldValue, errors }) => (
          <form>
            <div className='designation-field-wrapper flex justify-between'>
              <div className='designation-drawer-input'>
                <div className='designation-drawer-input-label'>
                  <NewInput
                    label='Designation Name'
                    placeholder='Enter designation name'
                    name='designationName'
                    width={'100%'}
                    type={'text'}
                    required={true}
                    onInput={handleInventory}
                  />
                </div>
              </div>

            </div>

            <div className='right-drawer-save'>
              <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                {UI_CONSTANT.SUBMIT}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Box>
  )

  const handleEditDesignationFormSubmit = (value) => {
    const data = {
      seteditDesignationDrawer,
      value
    }
    dispatch(editDesignation(data))
  }

  const EditDesignationData = (data) => {
    const editDesignationValidationSchema = Yup.object().shape({
      designationName: Yup.string().required('Designation name is required')
    })
    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>{UI_CONSTANT.MASTER_CONFIG.DESIGNATION.EDIT_DESIGNATION}</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForEditDesignation(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            designationId: data?.data?.designationId,
            designationName: data?.data?.designationName,
            status: data?.data?.status,
          }}
          validationSchema={editDesignationValidationSchema}
          onSubmit={(value) => {
            handleEditDesignationFormSubmit(value)
          }}
        >
          {({ values, handleSubmit, handleChange }) => (
            <form>
              <div className='designation-field-wrapper flex justify-between'>
                <div className='designation-drawer-input'>
                  <div className='designation-drawer-input-label'>
                    <NewInput
                      label='Designation Name'
                      placeholder='Enter designation name'
                      name='designationName'
                      width={'100%'}
                      type={'text'}
                      required={true}
                      value={values.designationName}
                      onInput={handleInventory}
                    />
                  </div>
                </div>

                <div className='designation-drawer-input1'>
                  <label className='designation-drawer-input-label' htmlFor=''>
                    Designation Status <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={statuses}
                    selectedValue={values.status}
                    className={'designation-drawer-option'}
                    onChange={handleChange}
                    name={'status'}
                    placeholder={'Select status'}
                  />
                  <ErrorMessage name='status' component='div' className='error-msg' />
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const nameBody = (designationTableData) => {
    const representative =
      designationTableData?.designationName && capitalizeFirstLetter(designationTableData?.designationName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const statusBody = (designationTableData) => {
    const representative =
      designationTableData?.status && capitalizeFirstLetter(designationTableData?.status)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
      />
    )
  }

  const verifiedBodyTemplate = (designationData) => {
    return (
      <>
        <PopupBox rowData={designationData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            <img src={HorizontalLine} alt='' />

            {UseAuthorization(permissions.EDIT_INVENTORY) && (
              <button className='div-assign-to-branch' onClick={toggleDrawerForEditDesignation(true, designationData)}>
                <img src={pencilIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>{UI_CONSTANT.MASTER_CONFIG.DESIGNATION.EDIT_DESIGNATION}</p>
              </button>
            )}
          </div>
        </PopupBox>
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'designationName',
      header: 'Designation Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'status',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { minWidth: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MASTER_CONFIG.DESIGNATION.LABEL_DESIGNATION,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.MASTER_CONFIG.DESIGNATION.LABEL_DESIGNATION,
      link: ROUTES_PATH.DESIGNATION,
    },
  ]

  return (
    <>
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && (
        <div className={`course-list }`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              {UseAuthorization(permissions.ADD_INVENTORY) && (
                <Button className='add-btn' onClick={toggleDrawer(true)}>
                  {UI_CONSTANT.MASTER_CONFIG.DESIGNATION.ADD_DESIGNATION}
                </Button>
              )}
            </div>
            <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
              {DrawerList}
            </RightDrawer>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper'>
                <b className='course-list1'>{UI_CONSTANT.MASTER_CONFIG.DESIGNATION.ALL_DESIGNATION}</b>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => setSelectedNumber(e.value)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>

            <div id='inventory-list-table' className='table-card'>
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                filters={filters}
                // loading={loading}
                columns={columns}
                onFilter={onFilter}
              />
            </div>
          </div>
          {/* <9/div> */}
          {editDesignationDrawer && (
            <RightDrawer anchor='right' isOpen={editDesignationDrawer} onClose={toggleDrawerForEditDesignation(false)}>
              <EditDesignationData data={singleDesignationData} />
            </RightDrawer>
          )}
        </div>
      )}
    </>
  )
}

export default Designation
